import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tablist"
export default class extends Controller {
  static targets = ["control"];

  connect() {
    this.element.querySelectorAll("button").forEach((button) => {
      const id = button.getAttribute("aria-controls");
      if (button.getAttribute("aria-selected")) {
        this.selectedId = id;
      }

      button.addEventListener("click", (event) => {
        this.switchTab(id);
      });
    });
  }

  switchTab(id) {
    this.hideTab(this.selectedId);
    this.selectedId = id;
    this.controlTarget.value = id.replace("-tabpanel", "");
    this.showTab(id);
  }

  hideTab(id) {
    const button = this.button(id);
    if (button) {
      button.removeAttribute("aria-selected");
    }

    const tabpanel = this.tabpanel(id);
    if (tabpanel) {
      tabpanel.classList.add("hidden");
    }
  }

  showTab(id) {
    const button = this.button(id);
    if (button) {
      button.setAttribute("aria-selected", true);
    }

    const tabpanel = this.tabpanel(id);
    if (tabpanel) {
      tabpanel.classList.remove("hidden");
      const input = tabpanel.querySelector("input:not([type=hidden])");
      if (input) {
        input.focus();
      }
    }
  }

  button(id) {
    if (!id) return;
    const selector = `button[aria-controls="${id}"]`;
    const button = this.element.querySelector(selector);
    if (button) {
      return button;
    } else {
      console.error("Tab not found", selector);
    }
  }

  tabpanel(id) {
    if (!id) return;
    const tabpanel = document.getElementById(id);
    if (tabpanel) {
      return tabpanel;
    } else {
      console.error("Tabpanel not found", `#${id}`);
    }
  }
}
